import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';

import CloseIcon from '@images/icons/24/close-icon.inline.svg';
import ArrowIcon from '@components/ArrowIcon/ArrowIcon';
import links from '@data/links.json';
import * as css from './ClientLoginMenu.module.css';

const ClientLoginMenu = ({ ...props }) => {
  const [navOpen, setNavOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setNavOpen(false);
    }
  };

  const toggleLoginNav = () => setNavOpen((value) => !value);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <section ref={ref} className={css.loginMenu}>
      <button
        type="button"
        aria-label="Client Login Menu"
        onClick={toggleLoginNav}
        className={cn(css.loginMenuButton, {
          [css.loginMenuButtonActive]: navOpen,
        })}
      >
        <span className="text-sm mr-3 font-medium text-brand-primary">
          Client Login
        </span>
        <div className={cn({ hidden: navOpen })}>
          <ArrowIcon />
        </div>
        <CloseIcon
          className={cn({ hidden: !navOpen, block: navOpen })}
          fill="white"
        />
      </button>
      <nav
        className={cn(css.loginNav, {
          hidden: !navOpen,
          block: navOpen,
          [css.loginNavFooter]: props.footer,
        })}
      >
        <div className={css.loginNav__inner}>
          <a
            className={css.loginNav__item}
            href={links.loginCoinbase}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Coinbase</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginEmoney}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Emoney</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginGoldmanSachs}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Goldman Sachs</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginMerrill}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Merrill</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginMorganStanley}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Morgan Stanley</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginNFS}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">NFS</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginNorthernTrust}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Northern Trust</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginRaymondJames}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Raymond James</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginRBC}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">RBC</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginRobinhood}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Robinhood</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginSchwab}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">Schwab</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginUBS}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">UBS</span>
            <ArrowIcon />
          </a>
          <a
            className={css.loginNav__item}
            href={links.loginUSTrust}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="flex-grow">U.S. Trust</span>
            <ArrowIcon />
          </a>
        </div>
      </nav>
    </section>
  );
};

export default ClientLoginMenu;
